function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "awesome-youtube",
  "data-name": "Icon awesome-youtube",
  d: "M79.8,13.349a10.106,10.106,0,0,0-7.111-7.157C66.416,4.5,41.265,4.5,41.265,4.5S16.114,4.5,9.842,6.192a10.106,10.106,0,0,0-7.111,7.157C1.05,19.662,1.05,32.833,1.05,32.833s0,13.172,1.681,19.485a9.956,9.956,0,0,0,7.111,7.043c6.272,1.692,31.424,1.692,31.424,1.692s25.151,0,31.424-1.692A9.956,9.956,0,0,0,79.8,52.318c1.681-6.313,1.681-19.485,1.681-19.485s0-13.172-1.681-19.485ZM33.039,44.792V20.874L54.061,32.834,33.039,44.792Z",
  transform: "translate(-1.05 -4.5)",
  fill: "#fff"
});

var SvgAwesomeYoutube = function SvgAwesomeYoutube(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 80.43 56.552",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwesomeYoutube, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/awesome-youtube.7a64b3dd.svg";
export { ForwardRef as ReactComponent };